const initialState = {
  isLogged: false,
  role: "admin"
};

export default initialState;
